/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './op-charge.reducer';

export const OPChargeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const oPChargeEntity = useAppSelector(state => state.oPCharge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="oPChargeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.oPCharge.detail.title">OPCharge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.oPCharge.id">Id</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.oPCharge.name">Name</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.oPCharge.description">Description</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.description}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.oPCharge.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.charge}</dd>
          <dt>
            <span id="chargeType">
              <Translate contentKey="tinyMedicRestApp.oPCharge.chargeType">Charge Type</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.chargeType}</dd>
          <dt>
            <span id="relatedTo">
              <Translate contentKey="tinyMedicRestApp.oPCharge.relatedTo">Related To</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.relatedTo}</dd>
          <dt>
            <span id="tax">
              <Translate contentKey="tinyMedicRestApp.oPCharge.tax">Tax</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.tax}</dd>
          <dt>
            <span id="emergencyHike">
              <Translate contentKey="tinyMedicRestApp.oPCharge.emergencyHike">Emergency Hike</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.emergencyHike}</dd>
          <dt>
            <span id="hishRiskHike">
              <Translate contentKey="tinyMedicRestApp.oPCharge.hishRiskHike">Hish Risk Hike</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.hishRiskHike}</dd>
          <dt>
            <span id="emergencyHikeType">
              <Translate contentKey="tinyMedicRestApp.oPCharge.emergencyHikeType">Emergency Hike Type</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.emergencyHikeType}</dd>
          <dt>
            <span id="hishRiskHikeType">
              <Translate contentKey="tinyMedicRestApp.oPCharge.hishRiskHikeType">Hish Risk Hike Type</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.hishRiskHikeType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.oPCharge.active">Active</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.oPCharge.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.oPCharge.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.oPCharge.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.oPCharge.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{oPChargeEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.oPCharge.hospital">Hospital</Translate>
          </dt>
          <dd>{oPChargeEntity.hospital ? oPChargeEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.oPCharge.scheme">Scheme</Translate>
          </dt>
          <dd>{oPChargeEntity.scheme ? oPChargeEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/op-charge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/op-charge/${oPChargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OPChargeDetail;
